export default {
  vehicle: "Vehicle",
  AddVehicle: "AddVehicle",
  editVehicle: "EditVehicle",
};
